export default {
  /**
   * @returns []
   */
  getXmlChannels(state) {
    const groupedXmlChannels = {};
    state.schedules.items.forEach((xmlChannel) => {
      let show = true;
      if (state.schedules.search) {
        const searchIn = xmlChannel.name + xmlChannel.webservice;
        show = searchIn.toLowerCase()
          .indexOf(state.schedules.search.toLowerCase()) !== -1;
      }

      if (show) {
        if (!groupedXmlChannels[xmlChannel.name]) {
          groupedXmlChannels[xmlChannel.name] = [];
        }
        groupedXmlChannels[xmlChannel.name].push(xmlChannel);
      }
    });
    const xmlChannels = [];
    Object.keys(groupedXmlChannels).forEach((name) => {
      xmlChannels.push({ name, items: groupedXmlChannels[name] });
    });

    // sort list of channels based on channelname
    xmlChannels.sort((a, b) => {
      if (a.name < b.name) {
        return -1;
      }
      if (a.name > b.name) {
        return 1;
      }
      return 0;
    });
    // sort list of webservices based on name
    xmlChannels.forEach((channel) => {
      channel.items.sort((a, b) => {
        if (a.webservice < b.webservice) {
          return -1;
        }
        if (a.webservice > b.webservice) {
          return 1;
        }
        return 0;
      });
    });
    return xmlChannels;
  },
  /**
   * @returns []
   */
  getXmlChannelsForEdit(state) {
    return state.editSchedules.items;
  },
  /**
   * @param state
   */
  getSubchannels(state) {
    if (
      state.editSchedules.items.subChannels !== undefined &&
      state.editSchedules.items.subChannels.length > 0
    ) {
      return state.editSchedules.items.subChannels.map(e => e.name);
    }
    return [];
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/schedules/getters.js